/**
 * @file common-card.component.ts
 * Carte de rareté COMMUN.
 *
 * Effets visuels :
 * - Dégradé gris (#d1d5db → #6b7280)
 * - Bordure statique (pas de rotation)
 * - Particules grises ascendantes uniquement
 * - Aucun effet spécial (pas de paillettes, étincelles ou foudre)
 *
 * Usage :
 * ```html
 * <app-common-card [card]="cardData" />
 * ```
 */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import {Card} from '@/app/shared/components/card/card.model';
import {CardComponent} from '@/app/shared/components/card/card.component';

@Component({
  selector: 'app-common-card',
  standalone: true,
  imports: [CardComponent],
  template: `
    <app-card
      rarity="COMMON"
      [name]="card.name"
      [score]="score"
      [rating]="card.rating"
      [image]="card.fileName"
      [backOfCard]="card.extension.cardBack"
      [extensionId]="card.extension.id"
      [initiallyFlipped]="initiallyFlipped"
      [interactive]="interactive"
      [author]="card.author"
    />
  `,
  host: { style: 'display: block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonCardComponent {
  /** Données complètes de la carte à afficher. */
  @Input({ required: true }) card!: Card;

  /** Score obtenu pour ce tirage — propre à l'instance, pas à la carte. */
  @Input({ required: true }) score!: number;

  /** Si `true`, la carte démarre côté dos. */
  @Input() initiallyFlipped = false;

  /**
   * Si `false`, désactive le tilt souris + halo hover interne de `CardComponent`.
   * Utile quand le survol/zoom est déjà géré par un composant parent
   * (ex. `CardsLayerComponent.enableHoverZoom()` dans l'ouverture de booster),
   * pour éviter deux systèmes de hover concurrents sur le même élément.
   */
  @Input() interactive = true;
}
